import abhi from "../images/abhishek.jpg";
import vedant from "../images/vedant.jpg";
import amit from "../images/amit.jpg";

export const recommendationsData = [
  
  {
    name: "Vedant Daigavne",
    designation: "SDE @Upstox",
    quote:
      "Yash is a hardworking guy who has the potential to manage a team, he has proved himself to be an important asset when it came to building real world applications by helping with the knowledge he has gained on working on his skill, he will give his best in any team he works with, may it be tech or non tech, he gets the work done.",
    image: vedant,
    linkedin: "https://www.linkedin.com/in/vedant-daigavane-25785315a/",
  },
  {
    name: "Amit Purohit",
    designation: "Graduate Analyst @Deutsche Bank",
    quote:
      "Yash is a very hardworking and dedicated individual. He likes taking initiatives and knows to work in a team also act as a leader. He knows to work effectively and efficiently in stressful environments. It was fun working with Yash.",
    image: amit,
    linkedin: "https://www.linkedin.com/in/amitpurohit47/",
  },
];
